import { Carousel } from '@mantine/carousel';
import { Tabs } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { accountPageModel, AccountPageTabValues } from '../../model';
import { AccountPageAccounts } from '../account-page-accounts';
import { AccountPageBonus } from '../account-page-bonus';
import { AccountPageCashdesks } from '../account-page-cashdesks';
import { AccountPageGameSettings } from '../account-page-game-settings';
import { AccountPageGames } from '../account-page-games';
import { AccountPageJackpot } from '../account-page-jackpot';
import { AccountPageSettings } from '../account-page-settings';
import { AccountPageTabUsers } from '../account-page-tab-users';
import { AccountPageTransactions } from '../account-page-transactions';
import { AccountPageWallets } from '../account-page-wallets';
import cls from './account-page-tabs.module.scss';

export const AccountPageTabs = () => {
	const { t } = useTranslation();

	const [currentTab, setCurrentTab] = useUnit([
		accountPageModel.$currentTab,
		accountPageModel.changeTab,
	]);

	return (
		<Tabs
			variant='default'
			defaultValue='wallets'
			keepMounted={false}
			classNames={{
				root: cls.accountPageTabs,
				panel: cls.accountPageTabsPanel,
			}}
			value={currentTab}
			onChange={(tab) => setCurrentTab(tab as AccountPageTabValues)}
		>
			<Tabs.List>
				<Carousel
					slideSize='11.1111111111%'
					emblaOptions={{ dragFree: true }}
				>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-wallets-tab'
							value='wallets'
						>
							{t('account-page.wallets')}
						</Tabs.Tab>
					</Carousel.Slide>
					{/* <Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-limits-tab'
							value='limits'
						>
							{t('account-page.limits')}
						</Tabs.Tab>
					</Carousel.Slide> */}
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-settings-tab'
							value='settings'
						>
							{t('account-page.settings')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-transactions-tab'
							value='transactions'
						>
							{t('account-page.transactions')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-accounts-tab'
							value='accounts'
						>
							{t('account-page.accounts')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-cashdesks-tab'
							value='cashdesks'
						>
							{t('account-page.cashdesks')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-users-tab'
							value='users'
						>
							{t('account-page.users')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-games-tab'
							value='games'
						>
							{t('account-page.games')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-game-settings-tab'
							value='game-settings'
						>
							{t('account-page.game-settings')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-jackpots-tab'
							value='jackpots'
						>
							{t('account-page.jackpots')}
						</Tabs.Tab>
					</Carousel.Slide>
					<Carousel.Slide>
						<Tabs.Tab
							data-test-id='account-page-bonuses-tab'
							value='bonuses'
						>
							{t('account-page.bonuses')}
						</Tabs.Tab>
					</Carousel.Slide>
				</Carousel>
			</Tabs.List>
			<Tabs.Panel value='wallets'>
				<AccountPageWallets />
			</Tabs.Panel>
			{/* <Tabs.Panel value='limits'>
				<AccountPageLimits />
			</Tabs.Panel> */}
			<Tabs.Panel value='settings'>
				<AccountPageSettings />
			</Tabs.Panel>
			<Tabs.Panel value='transactions'>
				<AccountPageTransactions />
			</Tabs.Panel>
			<Tabs.Panel value='accounts'>
				<AccountPageAccounts />
			</Tabs.Panel>
			<Tabs.Panel value='cashdesks'>
				<AccountPageCashdesks />
			</Tabs.Panel>
			<Tabs.Panel value='users'>
				<AccountPageTabUsers />
			</Tabs.Panel>
			<Tabs.Panel value='games'>
				<AccountPageGames />
			</Tabs.Panel>
			<Tabs.Panel value='game-settings'>
				<AccountPageGameSettings />
			</Tabs.Panel>
			<Tabs.Panel value='jackpots'>
				<AccountPageJackpot />
			</Tabs.Panel>
			<Tabs.Panel value='bonuses'>
				<AccountPageBonus />
			</Tabs.Panel>
		</Tabs>
	);
};
